<template>
  <div class="mydemand">
    <div class="page-title">
      <div>我的需求</div>
      <div class="process-createbtn-box">
        <el-button class="custom-button btn-ff3333 btn-create" @click="toDemandDetail()">发布需求</el-button>
      </div>
    </div>
    <div class="table-header-box cell-row">
      <div class="cell-column demandtype-cell">需求类型</div>
      <div class="cell-column projecttype-cell">项目类型</div>
      <div class="cell-column project-yusuan-cell">项目预算</div>
      <div class="cell-column demand-status-cell">状态</div>
      <div class="cell-column demand-publishtime-cell">发布时间</div>
      <div class="cell-column operate-cell">操作</div>
    </div>
    <div class="table-list-box" v-infinite-scroll="loadMoreData" :infinite-scroll-disabled="disabledLoadMore">
      <template v-if="demandList.length">
        <div v-for="(item, idx) in demandList" :key="idx" class="datalist-row cell-row">
          <div class="cell-column demandtype-cell">
            {{ item.mid_table_remark_001 | showLocalDictionaryVal(demandTypeList,'value','text') }}
          </div>
          <div class="cell-column projecttype-cell">
            {{ item.mid_table_remark_002 | showLocalDictionaryVal(demandProjectTypeList,'value','text') }}
          </div>
          <div class="cell-column project-yusuan-cell">
            {{ `${item.mid_table_remark_007}万` }}
          </div>
          <div :class="[
              'cell-column',
              'demand-status-cell',
              item.mid_table_remark_008 == 802 ? 'colblue' : '',
            ]">
            {{ item.mid_table_remark_008 == 802 ? "已受理" : "未受理" }}
          </div>
          <div class="cell-column demand-publishtime-cell">
            {{ item.time_insert|showTime }}
          </div>
          <div class="cell-column operate-cell">
            <div @click="toDemandDetail(item, 'edit')">
              {{ item.mid_table_remark_015 >= 3 ? "详情" : "编辑" }}
            </div>
            <div :class="!item.mid_table_remark_015 ? 'diabled' : ''" @click="handleFeedback(item)">
              查看反馈
            </div>
            <div @click="handleDelDemand(item,idx)">删除</div>
          </div>
        </div>
      </template>
      <NoneData v-else></NoneData>
    </div>
    <DialogFeedbackList ref="dialogFeedbackList"></DialogFeedbackList>
  </div>
</template>
<script>
import storage from "@/utils/customLocalStorage";
import NoneData from "@/components/NoneData";
import CustomSelect from "@/components/CustomSelect.vue";
import DialogFeedbackList from "@/components/dialog/FeedbackList";
import {
  demandTypeOptions,
  demandProjectTypeOptions,
} from "@/assets/js/dictionary";
import { checkDataFromDictionary, formatDate } from "@/utils/tool";
import lodash from "lodash";
import pageCommon from "@/utils/pagecommon";
import demandApi from "@/api/demand";
export default {
  name: "MyDemand",
  components: {
    CustomSelect,
    DialogFeedbackList,
    NoneData,
  },
  created() {
    let _this = this;
    _this.$store.dispatch("acCenterNavIndex", 6);

    _this.currentPage = 1;
    _this.total = 1;
    _this.demandList = [];
    _this.isRequesting = true;
    _this.getDemandList();
    _this.disabledLoadMore = false;
  },
  data() {
    return {
      demandTypeList: demandTypeOptions,
      demandProjectTypeList: demandProjectTypeOptions,
      demandList: [],
      currentPage: 1,
      pageSize: 10,
      total: 1,
      disabledLoadMore: false,
      isRequesting: false,
    };
  },
  computed: {
    userInfo: function () {
      let _this = this;
      let user = _this.$store.state.user;
      return user;
    },
  },
  mounted: function () {
    let _this = this;
  },
  filters: {
    showLocalDictionaryVal: function (val, list, checkprop, resultprop) {
      return checkDataFromDictionary(`${val}`, list, checkprop, resultprop);
    },
    showTime: function (val) {
      if (!val) {
        return;
      }
      let time = formatDate(
        new Date(val.replace(/-/g, "/")),
        "YYYY.MM.DD hh:mm:ss"
      );
      return time;
    },
  },
  methods: {
    getDemandList: function () {
      let _this = this;
      let requestData = {
        begin_idx: (_this.currentPage - 1) * _this.pageSize,
        limit: _this.pageSize,
        id_public_user_info: _this.userInfo.id_public_user_info,
        isloading: true,
      };
      pageCommon.apiRequestCommon(demandApi, "getList", requestData).then(
        (res) => {
          let demandList = res.page_content;
          console.log(demandList);
          if (demandList.length < _this.pageSize) {
            _this.disabledLoadMore = true;
          }
          // 用concat
          _this.demandList.push(...demandList);
          _this.total = res.result_num;
          _this.isRequesting = false;
        },
        (err) => {
          // _this.collectList = [];
          _this.isRequesting = false;
          _this.demandList = [];
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
        }
      );
    },
    loadMoreData: function () {
      let _this = this;
      if (_this.isRequesting) {
        return;
      }
      _this.isRequesting = true;
      _this.currentPage += 1;
      _this.getDemandList();
    },
    toDemandDetail: function (item) {
      let _this = this;
      let id = item ? item.id_public_middle_table : "";
      let operate = "edit";
      if (!item) {
        operate = "new";
      } else {
        if (Number(item.mid_table_remark_015) >= 3) {
          operate = "search";
        } else {
          operate = "edit";
        }
      }

      _this.$router.push({
        path: "/mydemanddetail",
        query: {
          id: id,
          o: operate,
        },
      });
    },
    handleFeedback: function (item) {
      let _this = this;
      if(!item.mid_table_remark_015){
        return;
      }

      let requestData = {
        begin_idx: 0,
        limit: 10,
        id_public_user_info: _this.userInfo.id_public_user_info,
        mid_table_remark_002: item.id_public_middle_table,
        isloading: true,
      };
      pageCommon.apiRequestCommon(demandApi, "checkFeedBack", requestData).then(
        (res) => {
          _this.$refs.dialogFeedbackList.showDialog = true;
          _this.$refs.dialogFeedbackList.dataList = res.page_content
          _this.isRequesting = false;
        },
        (err) => {
          _this.isRequesting = false;
        }
      )
    },
    handleDelDemand:function(item,idx){
      let _this = this;
      if (_this.isRequesting) {
        return;
      }
      _this.isRequesting = true;

      let page_content = {
        id_public_middle_table: item.id_public_middle_table,
        isloading: true,
      };
      pageCommon.apiRequestCommon(demandApi, "delDemand", page_content)
        .then(
          (res) => {
            _this.isRequesting = false;
            _this.$message.success("删除项目成功");
            _this.demandList.splice(idx, 1)
          },
          (err) => {
            _this.isRequesting = false;
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
              _this.$message.error(err.data.msg);
            }
          }
        );

    }
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
@import "../../assets/css/center.less";
.mydemand {
  position: relative;
  width: 100%;
  // height: 100%;
  height: 1131px;
  padding-left: 40px;
  padding-right: 40px;
  box-sizing: border-box;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  .page-title {
    position: relative;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .process-createbtn-box {
      position: relative;
      display: flex;
      display: -webkit-flex;
      flex-direction: row;
      align-items: center;
      .process-box {
        position: relative;
        display: flex;
        display: -webkit-flex;
        flex-direction: row;
        align-items: center;

        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ec4040;
        line-height: 16px;
        cursor: pointer;
        .icon-process {
          position: relative;
          width: 17px;
          height: 14px;
          margin-right: 6px;
        }
      }
      .btn-create {
        width: 90px;
        height: 36px;
        line-height: 36px;

        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        margin-left: 40px;
      }
    }
  }
  .cell-row {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    align-items: center;
    padding-left: 25px;
    padding-right: 25px;
    box-sizing: border-box;

    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    line-height: 16px;
    text-align: left;
    // margin-right: 20px;
  }
  .cell-column {
    position: relative;
    text-align: left;
    flex-shrink: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
  .demandtype-cell {
    position: relative;
    width: 202px;
  }
  .projecttype-cell {
    position: relative;
    width: 106px;
    text-align: center;
  }
  .project-yusuan-cell {
    position: relative;
    width: 180px;
    text-align: center;
  }
  .demand-status-cell {
    position: relative;
    width: 90px;
    text-align: center;
    &.colblue {
      color: #0072ff;
    }
  }
  .demand-publishtime-cell {
    position: relative;
    width: 210px;
    text-align: center;
  }

  .operate-cell {
    position: relative;
    width: 160px;
    text-align: center;
  }
  .table-header-box {
    position: relative;

    height: 60px;
    background: #f4f4f4;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    box-sizing: border-box;
    box-sizing: border-box;
    margin-top: 35px;
    margin-bottom: 24px;
    .status-cell {
      text-align: center;
    }
    .creattime-cell {
      text-align: center;
    }
  }
  .table-list-box {
    position: relative;
    flex: 1;
    width: 100%;
    margin-bottom: 24px;
    overflow: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .datalist-row {
    height: 100px;
    background: #ffffff;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    box-sizing: border-box;
    margin-bottom: 24px;
    &:nth-child(2n) {
      background: #f6f6f6;
    }
    &:last-child {
      margin-bottom: 0;
    }

    .cell-column {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #000000;
      &.colblue {
        color: #0072ff;
      }
    }
    .operate-cell {
      position: relative;
      display: flex;
      display: -webkit-flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ec4040;
      line-height: 16px;
      div {
        cursor: pointer;
      }
      .diabled {
        color: #ffa8a8;
        cursor: auto;
      }
    }
    .projecttype-cell,
    .project-yusuan-cell,
    .demand-status-cell,
    .demand-publishtime-cell {
      text-align: center;
    }
    .white-cell {
      text-align: center;
    }
  }
}
</style>
